import { Avatar, List, ListItem, ListItemAvatar, ListItemText, ListSubheader, Paper, Typography } from '@mui/material';
import { ImageFromServer } from '@/components/images/ImageFromServer';
import { EquipmentConfig } from '@/generated';
import { useEquipmentListQuery } from '@/hooks/query-hooks';
import { exerciseDetailsListStyle, exerciseDetailsListSubheaderStyle, exerciseDetailsPaperListElevation, exerciseDetailsPaperListStyle } from '@/styles';
import { ItemPreviewTooltip } from '@/components/ItemPreviewTooltip';

export const ExerciseEquipmentList = (props: { equipment: EquipmentConfig[] }) => {
  const { equipment } = props;
  return (
    <Paper sx={exerciseDetailsPaperListStyle} elevation={exerciseDetailsPaperListElevation}>
      <List sx={exerciseDetailsListStyle} component={'nav'}>
        <ListSubheader sx={exerciseDetailsListSubheaderStyle}>Equipment</ListSubheader>
        {equipment.map((e) => (
          <EquipmentListItem key={e.equipmentId} ecfg={e} />
        ))}
        {!equipment.length && (
          <ListItem>
            <ListItemText>No Equipment</ListItemText>
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

const EquipmentListItem = (props: { ecfg: EquipmentConfig }) => {
  const { ecfg } = props;
  const { equipmentList } = useEquipmentListQuery();
  const equipment = equipmentList?.find((e) => ecfg.equipmentId === e.id);
  const wh = 35;

  const content = (
    <ListItem>
      <ListItemAvatar>
        <Avatar sx={{ width: wh, height: wh, m: 1, backgroundColor: 'white' }}>
          <ImageFromServer sx={{ maxWidth: wh, maxHeight: wh }} thumbnail={true} alt="" id={equipment?.imageId} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText>
        {`${equipment?.name}`}
        {ecfg.optional ? ' (Optional)' : ''}
      </ListItemText>
    </ListItem>
  );

  return equipment ? (
    <ItemPreviewTooltip name={equipment.name} description={equipment.description} imageId={equipment.imageId}>
      {content}
    </ItemPreviewTooltip>
  ) : (
    content
  );
};

export const SimpleExerciseEquipmentList = (props: { equipmentConfigs: EquipmentConfig[] }) => {
  const { equipmentConfigs } = props;
  const { equipmentList } = useEquipmentListQuery();

  return (
    <Typography sx={{ display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }} variant="body2">
      Equipment: {equipmentConfigs.map((e) => equipmentList?.find((eq) => eq.id === e.equipmentId)?.name).join(', ')} {!equipmentConfigs?.length ? 'None' : ''}
    </Typography>
  );
};
